import path from '@/api/index'
import { axios } from '@/utils/request'

// 根据类型获取数据字典
export function getDictByType (typeValue) {
  return axios({
    url: path.sys + '/dict/getByType',
    method: 'POST',
    data: { 'type': typeValue }
  })
}

/**
 * 生成唯一ID
 * @param length 默认长度5
 */
export function genID (length = 5) {
  return Number(Math.random().toString().substr(3, length) + Date.now().toString()).toString(36)
}
